export default function NotFound() {
    return (
        <div className="p-5">
            <p className="font-ar text-lg text-black">No se encuentra la p&aacute;gina solicitada.</p>
        </div>
    )
}